import {observe, action, observable, autorun, computed, runInAction, reaction} from 'mobx';
import {autobind, nonenumerable} from 'spa/decorators';
import moment from 'moment';

import Cookies from 'js-cookie';

class SelectionState {
  get DATE_FORMAT() { return 'YYYY-MM-DD'; }

  @observable categoryGroup_id = undefined;
  @observable class_id = undefined;
  @observable country_id = undefined;
  @observable service_id = undefined;

  @observable date = undefined;

  getQuery(prevQuery, override) {
    const query = {
      ...prevQuery,
      ...this,
      ...override,
    };

    delete query.now;

    Object.keys(query)
      .forEach((key) => {
        switch (key) { // eslint-disable-line default-case
        case 'date':
        case 'country_id':
        case 'categoryGroup_id':
        case 'class_id':
        case 'service_id':
          if (query[key]) {
            query[key] += '';
          } else {
            delete query[key];
          }
          break;
        }
      });

    return query;
  }

  @action loadQuery(query) {
    /* eslint-disable no-param-reassign */

    if (moment.unix(query.date).isValid()) {
      query.date = moment.unix(query.date).format(this.DATE_FORMAT);
    }
    /* eslint-enable no-param-reassign */

    for (const key of Object.keys(this)) {
      let value = this[key];

      switch (key) {
      case 'country_id':
      case 'categoryGroup_id':
      case 'class_id':
      case 'service_id':
        value = query[key] ? `${query[key]}` : undefined;
        break;
      default:
        value = query[key] ? `${query[key]}` : undefined;
        break;
      }

      if (value !== this[key]) {
        this[key] = value;
      }
    }
  }

  @nonenumerable
  @observable
  now = moment().toJSON();

  @nonenumerable
  listeners = [
    reaction(
      () => this.promocode,
      () => {
        if (this.promocode && !Cookies.get('promocode')) {
          Cookies.set('promocode', this.promocode);
        }
      },
    ),
  ];

  @action reset() {
    // Classes
    this.categoryGroup_id = undefined;
    this.class_id = undefined;
    this.country_id = undefined;
    this.service_id = undefined;

    this.date = undefined;
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });

    // this is a hack for now to force the observable properties to initialize in this state - previous selection sets a value to null
    this.reset();

    this.listeners.push(clearInterval.bind(
      null,
      setInterval(action('heartbeat', () => {
        this.now = moment().toJSON();
      }), 60000),
    ));
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default SelectionState;



// WEBPACK FOOTER //
// ./spa/state/class-selection.jsx